import { useContext } from "react";
import { AppStateContext } from "../../state/AppProvider";

interface Props {
    message: string;
}

export const UserChatMessage = ({ message }: Props) => {
    const appStateContext = useContext(AppStateContext);
    return (
        <div className="w-full">
            <div className="transition-[padding] duration-200 py-[18px] px-4 text-base m-auto">
                <div className="mx-auto flex flex-1 text-base gap-4 lg:gap-6 lg:max-w-3xl">
                    <div className="flex w-full flex-col gap-1 items-end">
                        <div className="relative max-w-[70%] rounded-xl bg-j-green px-6 py-4 text-j-white shadow-[0px_8px_16px_rgba(0,0,0,0.14),0px_0px_2px_rgba(0,0,0,0.12)]">
                            {message}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
